module.exports = __webpack_public_path__ + "img/brand-logo.65257f0c.svg";